var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isGroup())?_c('MenuListItemGroup',{attrs:{"level":_vm.level,"item":_vm.item}}):_c('v-list-item',{attrs:{"link":""}},[_c('v-list-item-content',[_c('v-list-item-title',{style:(`margin-left:${_vm.marginLeft}`),on:{"click":function($event){return _vm.goTo(_vm.item.link)}}},[_vm._v(_vm._s(_vm.item.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }